<template>
  <div
    class="c-desktop-sub-nav j-nav-item"
  >
    <nuxt-link
      v-if="isLink"
      role="link"
      class="c-desktop-sub-nav__navigation"
      :to="navLink"
    >
      <span class="t-heading-9">{{ navItem.data.title }}</span>
    </nuxt-link>
    <button
      v-else
      class="c-desktop-sub-nav__navigation"
      type="button"
      :aria-expanded="(navVisible) ? 'true' : 'false'"
      @click="showSubMenu"
      @mouseover="hoverShow"
    >
      <span class="t-heading-9">{{ navItem.data.title }}</span>
    </button>
    <div
      v-if="subNavVisible"
      ref="menu"
      class="c-desktop-sub-nav__menu u-background-color-base j-nav-item__menu"
      :class="{
        'c-desktop-sub-nav__menu--showing': navVisible,
      }"
    >
      <nav-content
        ref="scroller"
        class="c-desktop-sub-nav__scroll l-container"
        :nav-item="navItem"
        :is-mobile="false"
      />
    </div>
    <svg
      v-if="!isLink"
      class="c-desktop-sub-nav__arrow"
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 0 24 24"
      width="24px"
      fill="#14457f"
    ><path
      d="M24 24H0V0h24v24z"
      fill="none"
      opacity=".87"
    /><path
      class="c-nav-item__arrow-path"
      d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z"
    /></svg>
  </div>
</template>

<script>
import NavContent from '../NavContent'
import SubNavMixin from '../SubNavMixin'
export default {
  name: "NavItem",
  components: {
    NavContent,
  },
  mixins: [
    SubNavMixin
  ],
  props:{
    searchVisible: {
      type: Boolean,
      default: false
    },
    drawingMenus: {
      type: Object,
      default: null
    },
    navVisible: {
      type: Boolean,
      default: false
    },
    navItemVisible: {
      type: Object,
      default: () => ({})
    },
    bannerHeight: {
      type: Object,
      default: () => {}
    },
    menuHeight: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      showingMenu: false,
      menuActive: false,
      menuBottom: null,
      menuTop: null,
      bounceTime: 0
    };
  },
  watch:{
    $route(){
      this.hideSubMenu();
    }
  },
  methods: {
    closeSearch() {
      this.$emit("hideSearch");
    },
    closeMenu(id) {
      this.$emit("hideDrawingMenu", id);
    },
    showMenu(id) {
      this.$emit("showDrawingMenu", id);
    },
    showSubMenu() {
      if (
        this.navItemVisible &&
        this.navItemVisible.open &&
        this.bounceCleared()
      ) {
        this.closeMenu(this.myIndex)
      } else {
        this.showMenu(this.myIndex)
      }
      this.startMouseTracking()
      if (this.bounceCleared()) {
        this.bounceTime = Date.now()
      }
      this.$nextTick(() => {
        this.sizeScroller()
        this.$nextTick(() => {
          this.findTop()
        })
      })
      setTimeout(() => {
        window.addEventListener("click", this.windowClick)
      }, 500)
    },
    hideSubMenu(){
      window.removeEventListener("click", this.windowClick)
      this.stopMouseTracking();
      this.closeMenu(this.myIndex)
    },
    windowClick(event) {
      try {
        let target = event.toElement;
        let isInMenu = false;

        while (target.parentElement){
          if (target.classList.contains("j-nav-item")) {
            isInMenu = true;
          }
          target = target.parentElement;
        }

        if (!isInMenu) {
          this.hideSubMenu();
        }
      } catch (err) {
        // console.warn(err);
      }
    },
    sizeScroller(){
      let scroller = this.$refs.scroller;
      if (scroller && scroller.style) {
        scroller.style.height = null;
      }
    },
    findTop(){
      let topEl = this.$refs.menu;
      let top = 0;
      let bannerEl = this.bannerHeight.el ? this.bannerHeight.el : null;
      let menuEl = this.menuHeight.el ? this.menuHeight.el : null;
      if (topEl && topEl.style && menuEl) {
        top += bannerEl ? bannerEl.getBoundingClientRect().height:0;
        top += menuEl ? menuEl.getBoundingClientRect().height:0;
        topEl.style.top = top + "px";
      }
    },
    hoverShow(){
      if(this.searchVisible){
        this.$emit("hideSearch");
        this.showSubMenu();
        this.startMouseTracking();
      }
      if(!this.menuActive){
        this.showSubMenu();
        this.startMouseTracking();
      }
    },
    startMouseTracking(){
      window.addEventListener("mousemove", this.trackMouse);
    },
    trackMouse(e) {
      try {
        /*
        if(!this.showingMenu || !this.menuActive){
          return;
        }
        */
        let menuEl = this.$refs.menu;
        if(menuEl){
          this.menuBottom = menuEl.getBoundingClientRect().bottom + 25;
          this.menuTop = menuEl.getBoundingClientRect().top;
        }
        let navItemEls = document.getElementsByClassName("c-desktop-nav__item");
        let navMenuLeft = null;
        let navMenuRight = null;
        if (navItemEls) {
          navMenuLeft = navItemEls[0].getBoundingClientRect().left;
          navMenuRight = navItemEls[navItemEls.length - 1].getBoundingClientRect().right + 25;
        }

        if(this.menuBottom !== null && this.menuTop !== null){
          if(this.menuBottom < e.clientY || e.clientY < 45){
            this.hideSubMenu();
          }
          if(this.menuTop > e.clientY && (e.clientX < navMenuLeft || e.clientX > navMenuRight)){
            this.hideSubMenu();
          }
        }
      } catch (err) {
        // console.warn(err)
      }
    },
    stopMouseTracking(){
      window.removeEventListener("mousemove", this.trackMouse)
    },
    bounceCleared(){
      return Date.now() > (this.bounceTime + 1000);
    }
  },
}
</script>
<style lang="scss" scoped>
  .c-desktop-sub-nav{
    position: relative;

    &__navigation{
      @include buttonReset;
      @include themify($themes){
        color: themed("foreground");
      }

      position: relative;
      cursor: pointer;
      display: block;
      width: 100%;
      text-align: left;
      text-decoration: none;
      &--right{
        float: right;
      }

      & > img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
        object-fit: cover;
      }
    }

    &__menu{
      position: fixed;
      top: rem(60px);
      left: 0;
      opacity: 0;
      width: 100%;
      transition: max-height 0.3s, opacity 0.2s;
      z-index: ($zindex-global-header - 1);
      max-height: 0%;
      padding: 0 rem(155px) 0 rem(140px);
      box-shadow: 0 2px 4px 0 #00000033;

      @include themify($themes){
        border-top: $border themed("background", "x-light");
      }

      @media only screen and (max-width: 1800px) {
        padding: 0 rem(90px) rem(31px) rem(80px);
      }

      @media only screen and (max-width: 1640px) {
        padding: 0 rem(45px) rem(31px) rem(40px);
      }

      @media only screen and (max-width: 1575px) {
        padding: 0 rem(35px) rem(31px) rem(40px);
      }

      @media only screen and (max-width: 1500px) {
        padding: 0 rem(20px) rem(31px) rem(10px);
      }

      &--showing{
        opacity: 1;
        max-height: 480px;
        overflow: hidden;
      }
    }

    &__close{
      @include buttonReset;
      cursor: pointer;
    }

    &__header{
      text-align: center;
      margin-top: rem(30px);
      &::after {
        @include themify($themes) {
          border-bottom: $border themed("background", "x-light");
        }
        content: "";
        display: block;
        margin: 0 auto;
        width: 50%;
        padding-top: rem(15px);
      }
    }

    &__scroll {
      padding: rem(20px) 0 0 0;
      margin-left: auto;
      margin-right: auto;
      @include respond("tab-land"){
        padding: rem(40px) 0 0 0;
      }
      @include respond("phone"){
        max-height: 100vh;
      }
    }

    &__secondary{
      &--desktop{
        float: left;
        width: 12%;
        position: sticky;
        top: 0;

        @media only screen and (max-width: 1500px) {
          width: 14%;
        }
      }
    }

    &__cards{
      float: right;
      width: 87%;
      grid-gap: 1rem;
      @media only screen and (max-width: 1500px) {
        width: 85%;
      }
      @include respond("tab-land"){
        float: none;
        width: inherit;
      }
    }

    &__card {
      height: 100%;
      display: flex;

      &--first::v-deep {
        padding: 4rem 1.9rem;

        .c-nav-card__wrapper {
          .c-nav-card__header {
            margin: 0.5rem 0 0 !important;
          }
        }
      }
    }

    &__arrow {
      position: absolute;
      right: 0;
      top: 0;
      transform: translate(100%);
    }
    &__arrow-path {
      @include themify($themes) {
        fill: themed("primary");
      }
    }
  }
</style>
